<template>
  <div class="submenubarDoc">
    <h1 class="medium-title warning-mobile">Submenu bar only showing in mobile screen.</h1>
    <saved-card :listUrl="urlList" />
  </div>
</template>

<script>
import SavedCard from '@/components/SubMenuBar'

export default {
  name: 'adx-submenubar-doc',
  components: {
    'saved-card': SavedCard
  },
  data() {
    return {
      urlList: [
        {
          'to': '#1',
          'title': 'experience',
        },
        {
          'to': '#2',
          'title': 'experience',
        },
        {
          'to': '#3',
          'title': 'experience',
        },
        {
          'to': '#4',
          'title': 'experience',
        },
        {
          'to': '#5',
          'title': 'experience',
        },
        {
          'to': '#6',
          'title': 'experience',
        },
        {
          'to': '#7',
          'title': 'experience',
        },
        {
          'to': '#8',
          'title': 'experience',
        },
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>